export const PRE_MANAGE_SUB_USER_PASSWORD = "sub-users/PRE_MANAGE_SUB_USER_PASSWORD";

export default function preManageSubUserPasswordAction() {
  return {
    "type": PRE_MANAGE_SUB_USER_PASSWORD
  };
}
